import {Component, EventEmitter, Input, NgZone, Output, ViewChild} from '@angular/core';
import {CommonConstant, CampaignInfluencerStatus} from '../../app.constants';
import {Country} from '../../../models/country';
import {InfluencerGroup} from '../../../models/influencer-group';
import {Platform} from '../../../models/platform';
import {AddInfluencerGroup, AddPostToProject, Influencer} from '../../../models/influencer';
import {AddInfluencersCampaign} from '../../../models/campaign/add-influencers-campaign';
import {GroupService} from '../../services/group-details/group.service';
import {UserService} from '../../services/user.service';
import {ModalService} from '../../services/modal/modal.service';
import {CampaignService} from '../../services/campaign/campaign.service';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {TranslateService} from '@ngx-translate/core';
import {DiscoverService} from '../../services/discover/discover.service';
import {InfluencerGroupsService} from '../influencer-groups/influencer-groups.service';
import {Project} from '../../../models/project/project';
import {InfluencerSuggestion} from '../../../models/influencer-suggestion';
import { ActivePages, EventTrackerService, UserActionType, Page, ActionSource, TargetType, ActionDetails } from '../../services/event-tracker/event-tracker.service';
import {ActivePage} from '../../../models/event-tracker';
import {InvalidAction, WallName} from '../../../models/user';
import {AddInfluencerGroupComponent} from '../group-details/add-influencer-group/add-influencer-group.component';
import {AddInfluencersToCampaignComponent} from '../group-details/add-influencers-to-campaign/add-influencers-to-campaign.component';
import {MoveInfluencerFromGroupComponent} from '../group-details/move-influencer-from-group/move-influencer-from-group.component';
import { AddInfluencerCampaignComponent } from '../campaigns/add-influencer-campaign/add-influencer-campaign.component';
import { Campaign } from '../../../models/campaign';
import {CampaignsDetailComponent} from '../campaigns-add/campaign-detail.component';
import { ObjectUtils } from '../../utils/object.utils';
import {AddPostsToProjectComponent} from './add-posts-to-project/add-posts-to-project.component';
import { WebUtils } from '../../utils/web.utils';

enum DiscoverTab {
  POST = 'posts',
  INFLUENCER = 'influencers'
}

@Component({
  selector: 'bottombar-influencer-fragement',
  templateUrl: './bottombar-influencer-fragement.component.html',
  styleUrls: ['./bottombar-influencer-fragement.component.scss']
})
export class BottombarInfluencerFragementComponent {

  @Input()
  public influencerList: Influencer[] = [];
  @Input()
  public postList: Influencer[] = [];
  @Input()
  public influencerGroupId: number;
  @Input()
  public influencerGroup: InfluencerGroup;
  @Input()
  public discoverInfluencer: boolean | false;
  @Input()
  public influencerGroupList: any[] = [];
  @Input()
  public projectList: any[] = [];
  @Input()
  public campaignList: any[] = [];
  @Input()
  public campaignListToPost: any[] = [];
  @Input()
  public campaignId: number;
  @Input()
  public campaignInfluencerList: boolean | false;
  @Input()
  public isArchivedCampaign: boolean;
  @Input()
  public isRecentlyVisitedInfluencerGroup: boolean;
  @Input()
  public isUsingForGroupDetail = false;
  @Output()
  public closeBottomBarCallback: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public openBottomBarCallback: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public clearSelectionCallback: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public previewBottomBarOpen: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public beforeAddingPendingInfluencerToGroup: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public addPendingInfluencerToGroupError: EventEmitter<any> = new EventEmitter<any>();

  // events use in Campaign Details page to add influencer to current active campaign and handle error
  @Output()
  public addInfluencerToCurrentCampaign: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public addInfluencerToCampaignError: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public addInfluencerAsAccepted: EventEmitter<any> = new EventEmitter<any>();

  // only use for discover clear result anfd filter
  @Output()
  public clearDiscoverResultAndFilter: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public beforeUpdateGroupEvent: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public afterUpdateGroupEvent: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public openGroupSetting: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public deleteInfluencerEvent: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public afterAddNewProject: EventEmitter<any> = new EventEmitter<any>();

  public showAddInfluencerToGroupFragment = false;
  public showPreviewSelectedInfluencerFragment = false;
  public showAddInfluencerToCampaignFragment = false;
  public showAddInfluencersToAnotherGroupFragment = false;
  public showAddPostToProjectFragment = false;
  public showCreateNewGroupFragment = false;
  public showCreateNewProjectFragment = false;
  public showAddInfluencerManuallyFragment = false;
  public showAddInfluencerToCampaigns = false;

  // This is used for temporary hidden create new group fragment
  public temporaryHidden = false;

  @ViewChild('AlertAddInfluencerToCampaignSuccess')
  public alertAddInfluencerToCampaignSuccess: AchooPopupComponent;
  @ViewChild('AlertAddInfluencerToGroupSuccess')
  public alertAddInfluencerToGroupSuccess: AchooPopupComponent;
  @ViewChild('WarningDeleteInfluencerDialog')
  public warningDeleteInfluencerDialog: AchooPopupComponent;
  @ViewChild('WarningClearSelectedInfluencerDialog')
  public WarningClearSelectedInfluencerDialog: AchooPopupComponent;
  @ViewChild('NotificationAfterAddPostToProject')
  public notificationAfterAddPostToProject: AchooPopupComponent;
  @ViewChild('AlertAddPostToCampaignSuccess')
  public alertAddPostToCampaignSuccess: AchooPopupComponent;
  @ViewChild('AddInfluencerToGroupFragment')
  public addInfluencerToGroupFragment: AddInfluencerGroupComponent;
  @ViewChild('AddInfluencerToCampaignFragment')
  public addInfluencerToCampaignFragment: AddInfluencersToCampaignComponent;
  @ViewChild('AddInfluencerToOtherGroupFragment')
  public addInfluencerToOtherGroupFragment: MoveInfluencerFromGroupComponent;
  @ViewChild('AlertAPIError')
  public serverErrorNotification: AchooPopupComponent;
  @ViewChild('AddInfluencerToCampaignErrorPopup')
  public addInfluencerToCampaignErrorPopup: AchooPopupComponent;
  @ViewChild('AddInfluencerCampaign')
  public addInfluencerCampaign: AddInfluencerCampaignComponent;
  @ViewChild('AddPostsToProject')
  public addPostsToProject: AddPostsToProjectComponent;

  @ViewChild('AddInfluencerToGroupErrorPopup')
  public addInfluencerToGroupErrorPopup: AchooPopupComponent;

  private addInfluencerToGroupErrorPopupRef;

  public totalInfluencer = 0;
  public selectedCampaign: AddInfluencersCampaign = new AddInfluencersCampaign();
  public countryList: Country[] = [];
  public platformList: Platform[] = [];
  public deleteInfluencers: any[] = [];
  public campaignNotificationMsg: string;
  public tabKey: string = DiscoverTab.INFLUENCER;
  public msgAddInfluencerToGroupSuccess: string;
  // error message
  public serverErrorMessage: string;

  // selected project to add posts
  public projectName: string;
  // create new project
  public newProject: Project = new Project();
  // this is used for revert data in case of error
  public previousProjectData: Project = new Project();

  // keep add influencer group data
  public addInfluencerGroup: AddInfluencerGroup;

  // keep the previous selected influencers
  public selectedInfluencerToAddGroup: InfluencerSuggestion[];
  // keep the index of selected influencer to add manually
  public indexInfluencerManually: number;
  public processingInfluencerSuggestion: InfluencerSuggestion;
  public addInfluencerToCampaignErrorMsg: string;
  // that use to store the list of influencer will be added to campaign
  public pendingInfluencerListAddToCampaign;

  // This flag use to indicate if user create new project to add post
  private isAddingPostToNewProject;

  // This flag use to show or hide country list in edit project component
  public showCountryList = true;

  // keep the previous selected influencers to add campaign
  public selectedInfluencerToAddCampaign: InfluencerSuggestion[];
  public addInfluencerToCampaignAsAccepted: boolean;

  public AddInfluencerToGroupFragment = false;

  // This is used for temporary hidden add influencer to group fragment
  public temporaryHiddenAddInfluencerToGroup = false;

  constructor(private groupService: GroupService,
              private userService: UserService,
              private referenceDataService: ReferenceDataService,
              private _ngZone: NgZone,
              private modalService: ModalService,
              private campaignService: CampaignService,
              private translateService: TranslateService,
              private discoverService: DiscoverService,
              private eventTracker: EventTrackerService,
              private influencerGroupService: InfluencerGroupsService) {
    this.countryList = this.referenceDataService.countries;
    this.platformList = this.referenceDataService.platforms;
    this.updateCountryCode();
  }

  get hasSelectedPost() {
    return this.countNumberReviewedPost > 0;
  }

  set hasSelectedPost(evt) {
    this._ngZone.runOutsideAngular(() => {
      this.postList.forEach((post) => {
        if (post.selected) {
          post.previewed = evt;
        }
      });
    });
  }

  get hasSelectedProfiles() {
    return this.countNumberReviewedInfluencer > 0;
  }

  set hasSelectedProfiles(evt) {
    this._ngZone.runOutsideAngular(() => {
      if (!evt) {
        this.showAddInfluencerToCampaigns = false;
        this.showAddInfluencerToGroupFragment = false;
      }
      this.influencerList.forEach((influencer) => {
        if (influencer.selected) {
          influencer.previewed = evt;
        }
      });
    });
  }

  closeWarningDeleteInfluencerPopup() {
    this.deleteInfluencers = [];
    this.modalService.close();
  }

  closeWarningClearSelectedInfluencerPopup() {
    this.deleteInfluencers = [];
    this.modalService.close();
  }

  showAlertSuccessAddInfluencerToCampaign() {
    const alert = this.alertAddInfluencerToCampaignSuccess;
    this.modalService.open(alert, () => {
      this.selectedCampaign = null;
    }, true);
  }

  showAlertSuccessAddPostsToCampaign() {
    const alert = this.alertAddPostToCampaignSuccess;
    this.modalService.open(alert, () => {
      this.selectedCampaign = null;
    }, true);
  }

  showAlertSuccessAddInfluencerToGroup() {
    this.modalService.open(this.alertAddInfluencerToGroupSuccess, undefined, true);
  }

  showWarningDeleteMultipleInfluencerPopup() {
    const selecteddInfluencers = this.selectedInfluencers.filter((influencer) => influencer.selected);
    this.showWarningDeleteInfluencerPopup(selecteddInfluencers);
  }

  reviewInfluencers() {
    const previewedInfluencers = this.selectedInfluencers.filter(influencer => influencer.previewed);
    if (previewedInfluencers.length === 0) {
      this.selectedInfluencers.forEach((influencer) => {
        influencer.previewed = true;
      });
    }

    const previewedPosts = this.selectedPosts.filter(post => post.previewed);
    if (previewedPosts.length === 0) {
      this.selectedPosts.forEach((influencer) => {
        influencer.previewed = true;
      });
    }

    if (this.selectedInfluencers.length > 0) {
      this.showPreviewInfluencer();
      this.replaceTabState(DiscoverTab.INFLUENCER);
    } else if (this.selectedPosts.length > 0)  {
      this.showPreviewInfluencer();
      this.replaceTabState(DiscoverTab.POST);
    }
  }

  onCheckAllPost(evt) {
    if (!evt) {
      return;
    }
    this.postList.forEach(p => p.previewed = evt.returnValue);
  }

  onClearDiscoverResultAndFilter() {
    if (!this.discoverInfluencer) {
      return;
    }
    this.clearDiscoverResultAndFilter.emit(this.tabKey);
  }

  showWarningDeleteInfluencerPopup(influencers: any[]) {
    this.deleteInfluencers = influencers;
    this.modalService.openInCenter(this.warningDeleteInfluencerDialog);
  }

  showWarningClearSelectedInfluencerPopup() {
    this.modalService.openInCenter(this.WarningClearSelectedInfluencerDialog);
  }

  shouldShowInfluencerActionButton() {
    return !this.showAddInfluencerToGroupFragment && !this.showAddInfluencerToCampaignFragment && !this.showAddPostToProjectFragment
      && !this.showCreateNewGroupFragment && !this.showCreateNewProjectFragment
      && !this.showAddInfluencerManuallyFragment
      && !this.showAddInfluencersToAnotherGroupFragment && (this.discoverInfluencer || (this.hasSelectedInfluencer() && !this.discoverInfluencer));
  }

  shouldShowActionButtons() {
    return this.discoverInfluencer && !this.showPreviewSelectedInfluencerFragment && !this.showAddPostToProjectFragment
      && !this.showCreateNewProjectFragment && !this.showAddInfluencerToCampaignFragment && !this.showCreateNewGroupFragment
      && !this.showAddInfluencersToAnotherGroupFragment && !this.showAddInfluencerManuallyFragment;
  }

  shouldShowGroupActionButton() {
    return !this.showAddInfluencerToGroupFragment && !this.showAddInfluencerManuallyFragment
            && !this.hasSelectedInfluencer() && !this.showAddInfluencerToCampaigns
            && !this.showCreateNewGroupFragment && !this.showCreateNewProjectFragment;
  }

  showNotificationAfterAddingPostToProject(projectName) {
    this.projectName = projectName;
    this.modalService.open(this.notificationAfterAddPostToProject,
      this.hideNotificationAddingPostToProject.bind(this), true);
  }

  hideNotificationAddingPostToProject() {
    this.projectName = undefined;
  }

  closeNotificationAddPostToProject() {
    this.hideNotificationAddingPostToProject();
    this.modalService.close();
  }

  hideAddToCampaignFragment(needToResetPendingData?: boolean) {
    if (needToResetPendingData) {
      this.selectedCampaign = null;
    }
    this.showAddInfluencerToCampaignFragment = false;
    this.showPreviewSelectedInfluencerFragment = true;
    this.openBottomBarToPreview();
  }

  hideMoveInfluencerFragment(needToDiscardPendingData?: boolean) {
    if (needToDiscardPendingData) {
      this.addInfluencerGroup = null;
    }
    this.showAddInfluencersToAnotherGroupFragment = false;
    this.showPreviewSelectedInfluencerFragment = true;
    this.openBottomBarToPreview();
  }

  hideAddPostToProjectFragment() {
    this.showAddPostToProjectFragment = false;
    this.showPreviewSelectedInfluencerFragment = true;
    this.openBottomBarToPreview();
  }

  previewSelectedInfluencersToCampaign() {
    const previewedInfluencers = this.selectedInfluencers.filter(influencer => influencer.previewed);
    if (previewedInfluencers.length === 0) {
      this.selectedInfluencers.forEach((influencer) => {
        influencer.previewed = true;
      });
    }

    // set timeout to run animation
    this.showPreviewInfluencer();
  }

  addSelectedInfluencersToGroup() {
    this.showPreviewSelectedInfluencerFragment = false;
    this.showAddingInfluencersToGroupFragment();
  }

  addSelectedPostsToProject() {
    this.showPreviewSelectedInfluencerFragment = false;
    this.showAddMultiplePostsToProject();
  }

  addSelectedInfluencersToCampaign() {
    this.showPreviewSelectedInfluencerFragment = false;
    this.showAddInfluencerToCampaignFragment = true;
    this.openBottomBarCallback.emit();
  }

  onClickOutSideBottomBar(evt) {
    if (this.showPreviewSelectedInfluencerFragment && document.contains(evt.target)) {
      this.clearPreviewedInfluencer();
    }
  }

  /**
   * Clear influencer selection
   * Clear influencer and post base on the current tab on bottombar
   */
  clearInfluencerSelection() {
    if (this.tabKey === DiscoverTab.INFLUENCER) {
      this.unCheckAllInfluencers();
      // move to posts tab if there is some data selected
      if (this.countNumberSelectedPost() > 0) {
        this.tabKey = DiscoverTab.POST;
      } else {
        this.closeBottomBarWithTransition();
      }
    } else if (this.tabKey === DiscoverTab.POST) {
      this.unCheckAllPosts();
      // move to influencers tab if there is some data selected
      if (this.countNumberSelectedInfluencer() > 0) {
        this.tabKey = DiscoverTab.INFLUENCER;
      } else {
        this.closeBottomBarWithTransition();
      }
    }
    this.modalService.close();
  }

  /**
   * Clear selected and previewed influencer and post
   * Base on the current tab on bottombar
   */
  clearPreviewedInfluencerOrPost() {
    if (this.tabKey === DiscoverTab.INFLUENCER || !this.discoverInfluencer) {
      this.influencerList.forEach((influencer) => {
        if (influencer.selected && influencer.previewed) {
          influencer.previewed = false;
          influencer.selected = false;
        }
      });
    } else if (this.tabKey === DiscoverTab.POST) {
      this.postList.forEach((influencer) => {
        if (influencer.selected && influencer.previewed) {
          influencer.previewed = false;
          influencer.selected = false;
        }
      });
    }
    if (this.isUsingForGroupDetail) {
      this.clearSelectionCallback.emit();
    }
    // move to posts tab if there is some data selected
    this.manageDisplayTabAndCloseBottombar();
    this.modalService.close();
  }

  /**
   * Clear previewed Influencers and Posts base on the selected tab
   * Display the next tab if there is some selected data
   */
  clearPreviewedInfluencer() {
    setTimeout(() => {
      this.closeAllActionsFragment();
    }, CommonConstant.TRANSITION_TIME);
    this.closeBottomBarCallback.emit(false);
    this.previewBottomBarOpen.emit(false);
  }
  /**
   * show fragement to add new influencer to group
   */
  showAddInfluencerFragment() {
    // set timeout for animation
    setTimeout(() => {
      if (this.campaignInfluencerList) {
        this.showAddInfluencerToCampaigns = true;
      } else {
        this.showAddInfluencerToGroupFragment = true;
        this.temporaryHiddenAddInfluencerToGroup = false;
      }
    }, CommonConstant.TRANSITION_TIME);

    this.openBottomBarCallback.emit();
  }

  closeAddInfluencerFragment(data?) {
    setTimeout(() => {
      if (this.campaignInfluencerList) {
        this.showAddInfluencerToCampaigns = false;
      } else {
        if (!data.isTemporaryHidden) {
          this.showAddInfluencerToGroupFragment = false;
          this.temporaryHiddenAddInfluencerToGroup = false;
        } else {
          this.temporaryHiddenAddInfluencerToGroup = true;
        }
      }
    }, CommonConstant.TRANSITION_TIME);

    if (data && data.resetSelectedInfluencer) {
      // clear cached influencer selection
      this.selectedInfluencerToAddGroup = [];
      this.addInfluencerGroup = null;
    }

    if (data) {
      this.closeBottomBarCallback.emit(data);
    }
  }

  /**
   * show fragment to move multiple influencers to other group
   */
  showAddingInfluencersToGroupFragment() {
    this.openBottomBarCallback.emit(CommonConstant.DEFAULT_BOTTOMBAR_MAX_HEIGHT);
    this.showAddInfluencersToAnotherGroupFragment = true;
  }

  /**
   * show fragment to move multiple influencers to other group
   */
  showAddMultiplePostsToProject() {
    // calculate expected fragment bottom bar height container
    const previewFragmentHeight = this.selectedPosts.length * CommonConstant.PREVIEW_ITEM_HEIGHT + CommonConstant.COLLAPSED_BOTTOMBAR_HEIGHT;
    if (previewFragmentHeight < 500) {
      this.openBottomBarCallback.emit(500);
    }
    this.showAddPostToProjectFragment = true;
  }

  closeMoveInfluencersToGroup() {
    setTimeout(() => {
      this.showAddInfluencersToAnotherGroupFragment = false;
    }, CommonConstant.TRANSITION_TIME);

    this.closeBottomBarCallback.emit(false);
  }

  showCreateProjectFragement(project, isAddingPost) {
    this.isAddingPostToNewProject = isAddingPost;
    this.showCountryList = isAddingPost;
    if (!project) {
      // initialize value for new project
      this.newProject = new Project();
      this.newProject.id = 0;
      this.newProject.countries = [];
    } else {
      this.newProject = project;
    }
    this.previousProjectData = ObjectUtils.deepClone(this.newProject);
    // show project creation fragment
    this.showAddPostToProjectFragment = false;
    this.showCreateNewProjectFragment = true;
  }

  beforeCreateOrUpdateProject() {
    if (!this.isAddingPostToNewProject) {
      this.showCreateNewProjectFragment = false;
      this.closeBottomBarWithTransition();
    }
  }

  closeEditProjectFragment(evt) {
    if (evt.isError) {
      this.newProject = this.previousProjectData;
      this.showCreateNewProjectFragment = true;
      this.openBottomBarCallback.emit();
    } else {
      if (this.isAddingPostToNewProject) {
        this.isAddingPostToNewProject = false;
        this.showCreateNewProjectFragment = false;
        this.showAddPostToProjectFragment = true;
        if (evt.isReloadList) {
          this.afterCreateProjectSuccess(evt);
        }
      } else {
        this.showCreateNewProjectFragment = false;
        this.closeBottomBarWithTransition();
      }
    }
  }

  replaceTabState(tabKey: string) {
    if (!this.showPreviewSelectedInfluencerFragment) {
      return;
    }
    this.tabKey = tabKey;
    const activedInfluencerTabWithoutSelectedInfluencer = tabKey === DiscoverTab.INFLUENCER && this.selectedInfluencers.length === 0;
    const activedPostTabWithoutSelectedPost = tabKey === DiscoverTab.POST && this.selectedPosts.length === 0;
    if (activedInfluencerTabWithoutSelectedInfluencer && activedPostTabWithoutSelectedPost) {
      this.showPreviewSelectedInfluencerFragment = false;
      this.closeBottomBarCallback.emit(false);
    }
  }

  /*Public method -----------------------------------------------*/

  /**
   * @param {AddInfluencerGroup} addInfluencerGroup
   */
  public addMoreInfluencerToCurrentGroup(data: any) {
    // clear cached selected influencer suggestions
    this.selectedInfluencerToAddGroup = data.selectedInfluencers;
    this.addInfluencerToGroup(data.addInfluencerGroup, false);
  }

  public addInfluencerToCampaign(addInfluencerCampaign: AddInfluencersCampaign) {
    // filter list of previewed influencers
    let previewedInfluencers = [];
    if (this.tabKey === DiscoverTab.INFLUENCER) {
      previewedInfluencers = this.influencerList.filter(
        (influencer: Influencer) => influencer.selected && influencer.previewed
      );
    }
    // prepare influencer data to webservice
    addInfluencerCampaign.influencers = previewedInfluencers.map((pi: Influencer) => ({
      influencer_id: pi.influencer_id,
      action: CommonConstant.ADD_ACTION,
      status: addInfluencerCampaign.is_accepted ? CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase() : ''
    }));

    // update selected campaign
    this.selectedCampaign = addInfluencerCampaign;
    // close add to campaign fragement
    this.hideAddToCampaignFragment();

    this.campaignService.addInfluencerToCampaign(addInfluencerCampaign).subscribe((res: any) => {
      if (!addInfluencerCampaign.is_accepted) {
        this.sendChamMixpanelEvent(true);
      }
      let messageTemplate;
      const param = {
        selected_campaign: this.selectedCampaign.campaign_name
      };
      // build notification message
      if (previewedInfluencers.length === 1) {
        messageTemplate = 'group_details.influencer.add_one_influencer_to_campaign';
      } else {
        messageTemplate = 'group_details.influencer.add_more_influencers_to_campaign';
      }
      this.campaignNotificationMsg = this.translateService.instant(messageTemplate, param);
      this.showAlertSuccessAddInfluencerToCampaign();
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
        id: addInfluencerCampaign.campaign_id,
        name: addInfluencerCampaign.campaign_name,
        type: TargetType.CAMPAIGN
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        ...addInfluencerCampaign
      }, undefined, this.getActivePage());
      this.userService.triggerUpdateActivatedInfluencers();
    }, // handler Error
    (err) => {
      // error by account level, show message
      this.addSelectedInfluencersToCampaign();
      if (err.error.data === 'invalid_level') {
        this.userService.doInvalidActionByLevel('Add to Campaign', err.error.message);
        this.sendInvalidActionToSegement(
          this.influencerGroupService.extractLimitInfoFromErrorMessage(
            err.error.message, addInfluencerCampaign.influencers.length, this.userService.maxCampaignInfluencers, true
          ), null, addInfluencerCampaign);
      } else if (err.error.data === 'archived_campaign') {
        this.modalService.openInCenter(this.addInfluencerToCampaignErrorPopup);
      }
    });
  }

  private getActivePage() {
    if (this.isUsingForGroupDetail) {
      return {
        type: ActivePages.GROUP_DETAILS,
        name: this.influencerGroup && this.influencerGroup.influencer_group_name ? this.influencerGroup.influencer_group_name : undefined,
        id: this.influencerGroupId ? this.influencerGroupId : undefined,
      };
    } else if (this.discoverInfluencer) {
      return {
        type: ActivePages.DISCOVER,
        name: undefined,
        id: undefined,
      };
    } else {
      const activeCampaign = this.campaignList.find(cp => cp.id === this.campaignId);
      if (activeCampaign) {
        return {
          type: ActivePages.CAMPAIGN_DETAILS,
          name: activeCampaign.name,
          id: activeCampaign.id,
        };
      }
      throw new Error('Not found active page');
    }
  }

  /**
   * this method is used to add multiple posts into selected campaign
   * @param {AddInfluencersCampaign} campaign
   */
  public addPostsToCampaign(campaign: AddInfluencersCampaign) {
    // filter list of previewed influencers
    let previewedPosts = [];
    previewedPosts = this.postList.filter(
      (influencer: Influencer) => influencer.selected && influencer.previewed
    );

    const postPaths = previewedPosts.map((post) => ({
      urlHash: post.url_hash,
      influencerId: post.influencer_id,
      url: post.fullUrl,
      relativepath: post.relativepath,
      publishDate: post.date,
      title: post.title,
      image: post.imageUrl,
      status: campaign.is_accepted ? 'accepted' : 'invited',
      channelId: post.channel ? post.channel.id : null
    }));

    this.hideAddToCampaignFragment();
    this.selectedCampaign = campaign;

    this.campaignService.addPostsToCampaign(campaign.campaign_id, postPaths).subscribe((res: any) => {
      // build notification message
      this.showAlertSuccessAddPostsToCampaign();
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
        id: campaign.campaign_id,
        name: campaign.campaign_name,
        type: TargetType.CAMPAIGN
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.ADDED_POSTS,
        ...previewedPosts
      }, undefined, {
        type: ActivePages.DISCOVER,
      });
      this.userService.triggerUpdateActivatedInfluencers();
    },
    (error) => {
      // reopen add influencer fragment if any error
      this.addSelectedInfluencersToCampaign();
      const serverError = CampaignsDetailComponent.buildMessageErrorInArchive(error.error, this.translateService);
      if (serverError.errorType === 'invalid level') {
        this.userService.doInvalidActionByLevel('Add to Campaign', serverError.errorMsg);
        this.sendInvalidActionToSegement(
          this.influencerGroupService.extractLimitInfoFromErrorMessage(
            error.error.message, postPaths.length, this.userService.maxCampaignInfluencers, true
          ), null, {
            campaign_id: campaign.campaign_id,
            campaign_name: campaign.campaign_name,
            posts: postPaths
          });
      } else {
        this.serverErrorMessage = serverError.errorMsg;
        this.modalService.open(this.serverErrorNotification, this.beforeClearErrorNotif.bind(this), true);
      }
    });
  }

  get numberPreviewedPost() {
    return this.postList.filter((influencer: Influencer) => influencer.selected && influencer.previewed).length;
  }

  /**
   * move one or more influencers from current active group
   * @param {number[]} selectedInfluencerIds
   */
  public executeAddingInfluencerToGroup(moveInfluencerGroup: AddInfluencerGroup) {
    if (this.discoverInfluencer && this.tabKey === DiscoverTab.POST) {
      // only allow move influencer in discover influencer tab or group details
      return;
    }
    // Get selected influencers
    const selectedAndPreviewedInfluencers = this.selectedInfluencers.filter((influencer) => influencer.previewed);

    // Get array of influencer IDs for selected influencers
    const influencerIdList = selectedAndPreviewedInfluencers.map((influencer) => influencer.influencer_id);

    // Filter unknown influencers from list of selected influencers
    moveInfluencerGroup.influencerList = influencerIdList.filter((id) => id > 0);

    // Move selected and existing influencers to new group
    const isMove = this.discoverInfluencer || this.campaignInfluencerList || this.isRecentlyVisitedInfluencerGroup ? false : true;
    this.addInfluencerToGroup(moveInfluencerGroup, isMove);
  }

  /**
   * using to add multiple post into project
   * @param {AddPostToProject} addPostToProject
   */
  public addMultiplePostIntoProject(addPostToProject: AddPostToProject) {
    if (this.tabKey !== DiscoverTab.POST) {
      // only allow move influencer in discover post tab
      return;
    }

    // Get selected influencers from post
    const selectedAndPreviewedPosts = this.selectedPosts.filter((post) => post.previewed);

    // transform to data structure to submit to server
    const postData = selectedAndPreviewedPosts.map((post) => ({
      postUrlHash: post.url_hash,
      postRelativePath: post.relativepath,
      channelId: post.channel ? post.channel.id : null
    }));

    addPostToProject.posts = postData;
    this.hideAddPostToProjectFragment();

    this.discoverService.addPostsToProject(addPostToProject).subscribe((res: any) => {
      this.showNotificationAfterAddingPostToProject(addPostToProject.projectName);
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.PROJECT, {
        id: addPostToProject.projectId,
        name: addPostToProject.projectName,
        type: TargetType.PROJECT
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.ADDED_POSTS,
        ...postData
      }, undefined, {
        type: ActivePages.DISCOVER,
      });
    });
  }

  public deleteSelectedInfluencers() {
    this.deleteInfluencerEvent.emit({
      influencerToDelete: this.deleteInfluencers
    });
    this.closeWarningDeleteInfluencerPopup();
  }

  public shouldDisableActionButtonGroup() {
    return this.showPreviewSelectedInfluencerFragment &&
           !this.hasPreviewedInfluencer();
  }

  get selectedInfluencers(): Influencer[] {
    return this.influencerList.filter((influencer) => influencer.selected);
  }

  get selectedPosts(): Influencer[] {
    return this.postList.filter((influencer) => influencer.selected);
  }

  get numOfInfluencerToDelete() {
    return this.deleteInfluencers.length;
  }

  beforeCreateOrUpdateGroup(evt) {
    this.beforeUpdateGroupEvent.emit(evt);
  }

  afterCreateOrUpdateGroup(evt) {
    if (evt && evt.isCreated) {
      this.afterCreateGroupSuccess(evt.data);
    } else {
      this.afterUpdateGroupEvent.emit(evt);
    }
  }

  /**
   * Callback after create new group
   */
  afterCreateGroupSuccess(persistedGroup) {
    this.showCreateNewGroupFragment = false;
    this.temporaryHiddenAddInfluencerToGroup = false;
    this.showAddingInfluencersToGroupFragment();
    const companyId = this.userService.getCompanyId();
    // load list influencer group
    this.influencerGroupService.getInfluencerGroupShortList(companyId).subscribe((res: any) => {
      this.influencerGroupList = res.map(group => ({
        id: group.id,
        name: group.name,
        description: group.description
      }));
      // Find the new group and add the selected influencers to new group
      const newGroup = res.find((group) => group.name === persistedGroup.name);
      if (newGroup && this.addInfluencerToOtherGroupFragment) {
        this.addInfluencerToOtherGroupFragment.influencerGroup.influencer_group_id = newGroup.id;
        this.addInfluencerToOtherGroupFragment.influencerGroup.influencerGroupName = newGroup.name;
        this.addInfluencerToOtherGroupFragment.influencerGroup.description = newGroup.description;
      }
    });
  }

  afterCreateProjectSuccess(newPersistedProject) {
    const newProject = {
      id: newPersistedProject.projectData.id,
      name: newPersistedProject.projectData.name,
      advertiserId: null,
      countries: newPersistedProject.projectData.projectCountries.map(item => item.country.id),
      keywords: newPersistedProject.projectData.projectKeywords.map(item => item.keyword)
    };
    this.afterAddNewProject.emit(newProject);
    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this.addPostsToProject) {
          this.addPostsToProject.onSelectProject(newProject);
        }
      });
    });
  }

  closeCreateGroupFragment() {
    this.showCreateNewGroupFragment = false;
    if (this.influencerGroup) {
      this.showAddInfluencersToAnotherGroupFragment = false;
      this.closeBottomBarCallback.emit();
    } else {
      this.showAddInfluencersToAnotherGroupFragment = true;
    }
  }

  openCreateNewGroupFragment(evt) {
    this.addInfluencerGroup = evt;
    this.influencerGroup = null;
    this.showAddInfluencersToAnotherGroupFragment = false;
    this.showCreateNewGroupFragment = true;
    this.temporaryHidden = false;
  }

  get messageWhenClearPreviewedItem() {
    if (this.tabKey === DiscoverTab.INFLUENCER || !this.discoverInfluencer) {
      return this.translateService.instant('discover.influencer.remove_influencer_selection_confirm', {
        totalInfluencer: this.influencerList.filter(influ => influ.previewed && influ.selected).length
      });
    } else {
      return this.translateService.instant('discover.influencer.remove_post_selection_confirm', {
        totalPost: this.postList.filter(influ => influ.previewed && influ.selected).length
      });
    }
  }

  closeConfirmationPopup() {
    this.modalService.close();
  }

  public contactSupport() {
    this.userService.contactSupport();
  }

  closeErrorAddingInfluencerAlert() {
    if (this.addInfluencerToGroupErrorPopupRef) {
      this.modalService.closeSinglePopup(this.addInfluencerToGroupErrorPopupRef);
    }
  }

  showFragmentAddInfluencerManually(evt) {
    // keep the previous selections
    this.indexInfluencerManually = evt.processingIndex;
    this.processingInfluencerSuggestion = evt.influencerSuggestion;
    if (this.isUsingForGroupDetail) {
      this.selectedInfluencerToAddGroup = evt.selectedInfluencers;
      this.showAddInfluencerToGroupFragment = false;
      this.addInfluencerGroup = evt.pendingAddInfluencerToGroup;
    }
    if (this.campaignInfluencerList) {
      this.pendingInfluencerListAddToCampaign = undefined;
      this.selectedInfluencerToAddCampaign = evt.selectedInfluencers;
      this.showAddInfluencerToCampaigns = false;
      this.addInfluencerToCampaignAsAccepted = evt.addInfluencerAsAccepted;
    }
    this.showAddInfluencerManuallyFragment = true;
  }

  closeFragmentAddInfluencerManually(influencer?: InfluencerSuggestion) {
    if (influencer && this.indexInfluencerManually && this.isUsingForGroupDetail) {
      this.selectedInfluencerToAddGroup.splice(this.indexInfluencerManually, 1, influencer);
    }
    if (influencer && this.campaignInfluencerList) {
      this.selectedInfluencerToAddCampaign.splice(this.indexInfluencerManually, 1, influencer);
    }
    this.processingInfluencerSuggestion = null;
    this.indexInfluencerManually = null;
    // keep the previous selections
    if (this.isUsingForGroupDetail) {
      this.showAddInfluencerToGroupFragment = true;
    }
    if (this.campaignInfluencerList) {
      this.showAddInfluencerToCampaigns = true;
    }
    this.showAddInfluencerManuallyFragment = false;
  }

  getWallNameForAddingInfluencer() {
    if (this.isUsingForGroupDetail) {
      return WallName.GROUPS_DISABLED;
    }
    if (this.campaignInfluencerList) {
      return WallName.CAMPAIGNS_DISABLED;
    }
    return null;
  }

  getActionLevelForAddingInfluencer() {
    if (this.isUsingForGroupDetail) {
      return CommonConstant.ADD_INFLUENCER_TO_GROUP;
    }
    if (this.campaignInfluencerList) {
      return CommonConstant.BASIC_CAMPAIGN_ACTION;
    }
    return null;
  }

  /*Private method -----------------------------------------------*/

  /**
   * this method is used to adda list of selected or previewed influencer to a Group
   * @param {AddInfluencerGroup} influencerToAdd
   * @param {boolean} isMove
   */
  private addInfluencerToGroup(influencerToAdd: AddInfluencerGroup, isMove: boolean) {
    this.addInfluencerGroup = influencerToAdd;

    // move influencer from one group to another group
    // use for discover and group details
    if (isMove) {
      this.hideMoveInfluencerFragment();
      if (influencerToAdd.addForReview) {
        this.addInfluencerToGroupAsPending(influencerToAdd, true);
      } else {
        this.doAddInfluencerToGroupManually(influencerToAdd);
      }

    } else {
      if (this.discoverInfluencer || this.campaignInfluencerList || this.isRecentlyVisitedInfluencerGroup) {
        this.hideMoveInfluencerFragment();
      }

      if (influencerToAdd.addForReview) {
        this.addInfluencerToGroupAsPending(influencerToAdd, false);
      } else {
        this.doAddInfluencerToGroupManually(influencerToAdd);
      }
    }
  }

  private moveInfluencerToAnotherGroup(influencerToAdd: AddInfluencerGroup) {
    this.groupService.moveInfluencerToGroup(this.influencerGroupId, influencerToAdd.influencerList,
      influencerToAdd.influencer_group_id, this.userService.getCompanyId()).subscribe((res) => {
      this.msgAddInfluencerToGroupSuccess = this.translateService.instant('group_details.influencer.add_influencer_to_group');
      this.showAlertSuccessAddInfluencerToGroup();
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
        id: influencerToAdd.influencer_group_id,
        name: influencerToAdd.influencerGroupName,
        type: TargetType.INFLUENCER_GROUP
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.MOVED_INFLUENCERS,
        ...influencerToAdd
      }, undefined, {
        type: this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.GROUP_DETAILS,
        name: !this.discoverInfluencer ? this.influencerGroup.influencer_group_name : undefined,
        id: !this.discoverInfluencer ? this.influencerGroupId : undefined,
      }, {
        source_type: TargetType.INFLUENCER_GROUP,
        source_name: this.influencerGroup.influencer_group_name,
        source_id: this.influencerGroupId
      });
    }, error => {
      if (error.error.data === 'invalid_level') {
        this.userService.doInvalidActionByLevel('Add to Group', error.error.message);
        this.sendInvalidActionToSegement(this.influencerGroupService.extractLimitInfoFromErrorMessage(
          error.error.message, influencerToAdd.influencerList.length, this.userService.maxGroupInfluencers, false
        ), influencerToAdd, null);
      }
    });
  }

  private addInfluencerToGroupAsPending(influencerToAdd: AddInfluencerGroup, isMove: boolean) {
    if (this.isUsingForGroupDetail && !isMove) {
      this.beforeAddingPendingInfluencerToGroup.emit(this.selectedInfluencerToAddGroup);
    }
    this.groupService.addInfluencerToGroupAsPending(influencerToAdd).subscribe((res) => {
      this.afterAddingInfluencerToGroupSuccess(influencerToAdd, true);
    }, err => {
      if (this.isUsingForGroupDetail && !isMove) {
        // this feature only aupport in group details page
        this.addPendingInfluencerToGroupError.emit();
        this.showAddInfluencerFragment();
      } else {
        this.showAddingInfluencersToGroupFragment();
      }
      this.addInfluencerToGroupErrorPopupRef = this.modalService.openInCenter(this.addInfluencerToGroupErrorPopup);
    });
  }

  private doAddInfluencerToGroupManually(influencerToAdd: AddInfluencerGroup) {
    this.groupService.addInfluencerToGroup(influencerToAdd).subscribe((res: any) => {
      this.afterAddingInfluencerToGroupSuccess(influencerToAdd, false);
      this.sendChamMixpanelEvent(false);
    }, err => {
      if (this.isUsingForGroupDetail) {
        // this feature only aupport in group details page
        this.showAddInfluencerFragment();
      } else {
        this.showAddingInfluencersToGroupFragment();
      }
      if (err.error && err.error.data === 'invalid_level') {
        this.userService.doInvalidActionByLevel('Add to Group', err.error.message);
        this.sendInvalidActionToSegement(
          this.influencerGroupService.extractLimitInfoFromErrorMessage(
            err.error.message, influencerToAdd.influencerList.length,
            this.userService.maxGroupInfluencers, false
          ), influencerToAdd, null);
      } else {
        this.addInfluencerToGroupErrorPopupRef = this.modalService.openInCenter(this.addInfluencerToGroupErrorPopup);
      }
    });
  }

  private afterAddingInfluencerToGroupSuccess(influencerToAdd: AddInfluencerGroup, addForReview: boolean) {
    if (addForReview) {
      this.msgAddInfluencerToGroupSuccess = this.translateService.instant('group_details.influencer.add_influencer_as_pending');
    } else {
      const messageKey = influencerToAdd.influencerList.length > 1
        ? 'group_details.influencer.add_new_influencers_to_current_group'
        : 'group_details.influencer.add_new_influencer_to_current_group';
      this.msgAddInfluencerToGroupSuccess = this.translateService.instant(messageKey,
        {
          numOfInfluencer: influencerToAdd.influencerList.length,
          groupName: influencerToAdd.influencerGroupName
        });
    }
    this.showAlertSuccessAddInfluencerToGroup();

    // when add influencer from previewed. Do not close bottom bar. Just back to previewed list
    if (!this.showPreviewSelectedInfluencerFragment) {
      this.closeAddInfluencerFragment({
        resetSelectedInfluencer: true,
        isReloadInfluencerList: true
      });
    }

    if (!addForReview) {
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
        id: influencerToAdd.influencer_group_id,
        name: influencerToAdd.influencerGroupName,
        type: TargetType.INFLUENCER_GROUP
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        ...influencerToAdd
      }, undefined, {
        type: this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.GROUP_DETAILS,
        name: !this.discoverInfluencer ? influencerToAdd.influencerGroupName : undefined,
        id: !this.discoverInfluencer ? influencerToAdd.influencer_group_id : undefined,
      });
    }
    // clear cached influencer selection
    this.selectedInfluencerToAddGroup = [];
    this.addInfluencerGroup = null;
  }

  private sendInvalidActionToSegement(limitInfo, influencerAddToGroup, influencerAddToCampaign) {
    const detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true,
      limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);

    // send event when adding influencer to group
    if (influencerAddToGroup) {
      this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.GROUP, {
        id: influencerAddToGroup.influencer_group_id,
        name: influencerAddToGroup.influencerGroupName,
        type: TargetType.INFLUENCER_GROUP
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        ...influencerAddToGroup
      }, undefined, {
        type: this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.GROUP_DETAILS,
        name: !this.discoverInfluencer ? influencerAddToGroup.influencerGroupName : undefined,
        id: !this.discoverInfluencer ? influencerAddToGroup.influencer_group_id : undefined,
      });
    }

    // send event when adding to Campaign
    if (influencerAddToCampaign) {
      this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.CAMPAIGN, {
        id: influencerAddToCampaign.campaign_id,
        name: influencerAddToCampaign.campaign_name,
        type: TargetType.CAMPAIGN
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        ...influencerAddToCampaign
      }, undefined, {
        type: this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.CAMPAIGN_DETAILS,
        name: !this.discoverInfluencer ? influencerAddToCampaign.campaign_name : undefined,
        id: !this.discoverInfluencer ? influencerAddToCampaign.campaign_id : undefined,
      });
    }
  }

  private updateCountryCode() {
    this.influencerList.forEach((influencer) => {
      influencer.country_code = this.findCountryCodeByName(influencer.country.name);
    });
  }

  private findCountryCodeByName(countryName: string) {
    const [matchCountry] = this.countryList.filter((country) => country.name === countryName);
    return matchCountry !== undefined ? matchCountry.code : null;
  }

  private beforeClearErrorNotif() {
    this.serverErrorMessage = null;
  }

  private closeAllActionsFragment() {
    this.showAddInfluencerToCampaignFragment = false;
    this.showPreviewSelectedInfluencerFragment = false;
    this.showAddInfluencersToAnotherGroupFragment = false;
  }

  private hasSelectedInfluencer() {
    if (this.postList) {
      return this.countNumberSelectedInfluencer() > 0 || this.countNumberSelectedPost() > 0;
    } else {
      return this.countNumberSelectedInfluencer() > 0;
    }
  }

  private countNumberSelectedInfluencer() {
    return this.influencerList.filter((influencer) => influencer.selected === true).length;
  }

  private countNumberSelectedPost() {
    return this.postList.filter((influencer) => influencer.selected === true).length;
  }

  get countNumberReviewedInfluencer() {
    return this.influencerList.filter((influencer) => influencer.selected && influencer.previewed).length;
  }

  get countNumberReviewedPost() {
    return this.postList.filter((post) => post.selected && post.previewed).length;
  }

  private hasPreviewedInfluencer() {
    const listPreviewedInfluencer = this.influencerList.filter(
      (influencer) => influencer.selected && influencer.previewed
    );

    const listPreviewedPost = this.postList.filter(
      (influencer) => influencer.selected && influencer.previewed
    );

    return listPreviewedInfluencer.length > 0 || listPreviewedPost.length > 0;
  }

  private openBottomBarToPreview() {
    this.openBottomBarCallback.emit(CommonConstant.DEFAULT_BOTTOMBAR_MAX_HEIGHT);
  }

  private showPreviewInfluencer() {
    this.showPreviewSelectedInfluencerFragment = true;
    this.openBottomBarToPreview();
  }

  private closeBottomBarWithTransition() {
    setTimeout(() => {
      this.closeAllActionsFragment();
    }, CommonConstant.TRANSITION_TIME);

    this.clearSelectionCallback.emit(this.tabKey);
    this.closeBottomBarCallback.emit(false);
  }

  private manageDisplayTabAndCloseBottombar() {
    if (this.countNumberSelectedInfluencer() === 0 && this.countNumberSelectedPost() === 0) {
      this.previewBottomBarOpen.emit(false);
      this.closeBottomBarWithTransition();
    } else {
      if (this.tabKey === DiscoverTab.INFLUENCER && this.countNumberSelectedInfluencer() > 0) {
        return;
      }
      if (this.tabKey === DiscoverTab.POST && this.countNumberSelectedPost() > 0) {
        return;
      }
    }
  }

  private unCheckAllInfluencers() {
    this.influencerList.forEach((influencer) => {
      influencer.selected = false;
      influencer.previewed = false;
    });
  }

  private unCheckAllPosts() {
    this.postList.forEach((post) => {
      post.selected = false;
      post.previewed = false;
    });
  }

  get activePage(): ActivePage {
    return {
      type: this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.GROUP_DETAILS
    };
  }

  groupSettingActionData() {
    return {
      action: UserActionType.ACTION,
      item: Page.GROUP,
      target: {
        type: TargetType.INFLUENCER_GROUP
      },
      params: {
        action: UserActionType.UPDATE,
        source: ActionSource.PAGE,
        actionDetails: ActionDetails.UPDATE_CONFIG,
      },
      activePage: {
        type: ActivePages.GROUP_DETAILS,
      }
    };
  }

  actionDataForAddingInfluencer() {
    if (this.campaignInfluencerList) {
      return this.actionData('campaign');
    }
    if (this.isUsingForGroupDetail) {
      return this.actionData('group');
    }
    return null;
  }

  /**
   * data will be used to send to Segment
   * @returns {{action: UserActionType; item: Page; target: ({type: Page} | {id: (number | any); name: (string | any); type: TargetType}); params: {action: UserActionType; source: ActionSource; actionDetails: ActionDetails}; activePage: {type: ActivePages}}}
   */
  actionData(target) {
    const item = target === 'group' ? Page.GROUP : target === 'campaign' ? Page.CAMPAIGN : Page.PROJECT;
    return {
      action: UserActionType.ACTION, item,
      target: {
        type: item
      },
      params: {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
      },
      activePage: {
        type: this.discoverInfluencer ? ActivePages.DISCOVER : this.isUsingForGroupDetail ? ActivePages.GROUP_DETAILS : ActivePages.CAMPAIGN_DETAILS,
      }
    };
  }

  get selectedProfileLabel() {
    if (this.campaignInfluencerList || this.isRecentlyVisitedInfluencerGroup) {
      return this.translateService.instant('campaigns.selected_campaign_influencer', {selected_number: this.countNumberSelectedInfluencer()});
    } else {
      return this.translateService.instant('group_details.search_bar.selected_influencer', {selected_number: this.countNumberSelectedInfluencer()});
    }
  }

  // get account level action for delete button depend on the context
  get actionByLevel() {
    // not support this button in discover
    if (this.discoverInfluencer) {
      return null;
    }
    if (this.campaignInfluencerList) {
      return CommonConstant.BASIC_CAMPAIGN_ACTION;
    } else {
      return CommonConstant.DELETE_INFLUENCER_FROM_GROUP;
    }
  }

  get wallName() {
    // not support this button in discover
    if (this.discoverInfluencer) {
      return null;
    }
    if (this.campaignInfluencerList) {
      return WallName.CAMPAIGNS_DISABLED;
    } else {
      return WallName.GROUPS_DISABLED;
    }
  }

  getCampaign() {
    const currentCampaign: Campaign = new Campaign();
    currentCampaign.id = this.campaignId;
    return currentCampaign;
  }

  get deleteInfluencerContext() {
    if (this.campaignInfluencerList) {
      return this.translateService.instant('common.campaign');
    } else {
      return this.translateService.instant('common.group');
    }
  }

  closeAddInfluencerToCampaign(data) {
    if (data.resetSelectedInfluencer) {
      this.pendingInfluencerListAddToCampaign = [];
    }
    this.selectedInfluencerToAddCampaign = [];
    this.showAddInfluencerToCampaigns = false;
    this.addInfluencerToCampaignAsAccepted = false;
    this.closeBottomBarCallback.emit();
  }

  addMoreInfluencerToCampaign(influencerData) {
    let isAccepted;
    // get current campaign info
    const currentCampaign = this.campaignList.find(campItem => campItem.id === this.campaignId);
    const campaignInfluencers = [];
    this.pendingInfluencerListAddToCampaign = influencerData;
    // update UI
    influencerData.forEach(influencer => {
      isAccepted = influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name;
      const influencerCountry = this.extractInfluencerCountry(influencer);
      campaignInfluencers.push({
        campaign_influencer_id: null,
        influencer_id: influencer.influencer_id,
        influencer_name: influencer.influencerName,
        influencerStatus: influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name ? influencer.status.toLowerCase() : CampaignInfluencerStatus.NEW.toLowerCase(),
        numberOfPosts: influencer.numberOfPosts,
        reach: influencer.reach,
        engagement: influencer.engagement,
        impact: influencer.impact,
        influencer_profile_picture: influencer.profilePicture,
        country_code: influencerCountry.code,
        country: {
          name: influencerCountry.name,
          code: influencerCountry.code
        },
        is_accepted: influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name
      });
      influencer.status = influencer.status.toLowerCase();
    });
    let filteredNewAcceptInfluencer = [];
    filteredNewAcceptInfluencer = campaignInfluencers.filter(item => item.is_accepted);
    this.addInfluencerToCurrentCampaign.emit(campaignInfluencers);
    this.closeAddInfluencerToCampaign({
      resetSelectedInfluencer: false
    });
    // Call WS
    const data = new AddInfluencersCampaign();
    data.campaign_id = this.campaignId;
    data.influencers = influencerData;
    data.is_accepted = isAccepted;
    this.campaignService.addInfluencerToCampaign(data).subscribe((res: any) => {
      if (filteredNewAcceptInfluencer && filteredNewAcceptInfluencer.length > 0) {
        this.addInfluencerAsAccepted.emit();
      }
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
        id: currentCampaign.id,
        name: currentCampaign.name,
        type: TargetType.CAMPAIGN
      }, {
        action: UserActionType.UPDATE,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        source: ActionSource.ACTION_VIEW,
        ...data
      }, undefined, {
        type: ActivePages.CAMPAIGN_DETAILS,
      });

      // Tracking cham event
      if (filteredNewAcceptInfluencer && filteredNewAcceptInfluencer.length === 0) {
        this.sendChamMixpanelEvent(true);
      }

      // clean cached influencer list
      this.pendingInfluencerListAddToCampaign = [];
      this.selectedInfluencerToAddCampaign = [];
      this.addInfluencerToCampaignAsAccepted = false;

      this.userService.triggerUpdateActivatedInfluencers();
    }, (error) => {
      this.showAddInfluencerFragment();
      this.addInfluencerToCampaignError.emit();
      if (error && error.error.data === 'invalid_level') {
        this.userService.doInvalidActionByLevel('Add to Campaign', error.error.message);
        this.sendInvalidActionToSegement(
          this.influencerGroupService.extractLimitInfoFromErrorMessage(
            error.error.message, influencerData.length,
            this.userService.maxGroupInfluencers, false
          ), null, {
            campaign_id: currentCampaign.id,
            campaign_name: currentCampaign.name,
            influencers: influencerData
          });
      }
    });
  }

  private sendChamMixpanelEvent(isAddedInfluencerToCampaign: boolean) {
    if (isAddedInfluencerToCampaign) {
      this.eventTracker.trackUserAction(UserActionType.CHAM_INVITED_CAMPAIGN_INFLUENCER);
    } else {
      this.eventTracker.trackUserAction(UserActionType.CHAM_ADD_INFLUENCER_TO_GROUP);
    }
  }

  private extractInfluencerCountry(influencer) {
    if (influencer.country) {
      return influencer.country;
    } else if (influencer.countryCode) {
      return this.referenceDataService.countries.find(item => item.code === influencer.countryCode);
    } else {
      return CommonConstant.INTERNATIONAL_COUNTRY_DATA;
    }
  }

  showGroupSettings() {
    if (this.isUsingForGroupDetail) {
      this.openGroupSetting.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/bottombar-influencer-fragement.component.ts